const dialogModalActionsTypes = {
    OPEN_DIALOG_MODAL: "OPEN_DIALOG_MODAL", 
    CLOSE_DIALOG_MODAL: "CLOSE_DIALOG_MODAL" 
};

export default dialogModalActionsTypes;